import { get, post, patch, deleteReq } from "../helpers/fetcher";

export const postSettings = async (body) => {
  const endpoint = "/settings";
  const header = { "Content-Type": "application/json" };

  return post(endpoint, header, body);
};